import * as React from 'react';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
import renderIcon from 'helpers/renderIcon';
import { dropdown, IDropdownProps } from 'helpers/hooks';
import { Link } from 'react-router';
import { manageShopLinksAdmin, manageShopLinksMember } from 'models/shop/manageshop';
import { IUserPreferences } from 'models/user/userpreferences';
const { connect } = require('react-redux');
import { IStore } from 'redux/IStore';
import { isAdmin } from 'redux/modules/shop/helpers';

interface IProps extends IDropdownProps {
	t?: (x: string) => string;
	shopId: string;
	userPreferences?: IUserPreferences;
}

interface IPropsPreferences extends React.PropsWithChildren<{}> {
	userPreferences?: IUserPreferences;
}

@connect((state: IStore) => {
	return {
		userPreferences: state.userPreferences,
	};
})
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
@dropdown()
class SettingsDropdown extends React.Component<IProps, IPropsPreferences> {
	constructor(props) {
		super(props);
	}

	public render() {
		const { open, t, toggle, shopId, userPreferences } = this.props;

		const isShopAdmin = isAdmin(shopId, userPreferences?.userRoles);
		const manageShopLinks = isShopAdmin ? manageShopLinksAdmin : manageShopLinksMember;

		return (
			<div className="dropdownHolder shopCardSettingsHolder" ref={this.props.ref1}>
				<a className="iconBtn" title={t('User_NotificationSettings_Title')} onClick={toggle}>
					{renderIcon('more')}
				</a>
				<div className="dropdown shopCardSettingsDropdown" style={{ display: open ? 'flex' : 'none' }}>
					{manageShopLinks &&
						manageShopLinks.reduce((prev, item) => {
							if (item.inHeader && !item.isShopLink)
								prev.push(
									<Link to={`/shop/${this.props.shopId}/${item.slug}`} className="settingsLink" key={item.slug}>
										{renderIcon(item.icon)}
										<span>{t(item.title)}</span>
									</Link>,
								);
							return prev;
						}, [])}
				</div>
			</div>
		);
	}
}
export { SettingsDropdown };
